
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class RisorseChecklistGrid extends Serenity.EntityGrid<RisorseChecklistRow, any> {
        protected getColumnsKey() { return RisorseChecklistColumns.columnsKey; }
        protected getDialogType() { return RisorseChecklistDialog; }
        protected getIdProperty() { return RisorseChecklistRow.idProperty; }
        protected getInsertPermission() { return RisorseChecklistRow.insertPermission; }
        protected getLocalTextPrefix() { return RisorseChecklistRow.localTextPrefix; }
        protected getService() { return RisorseChecklistService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}